import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet, apiPost } from "../utils/api_service";
const initialState = {
  beat: [],
  beatNew: [],
  beatIds: [],
  beatByUserType: [],
  beatFromSalesTeamId: [],
  beatClaim: {},
  outletEnquiryBeat: {},
};
let URL = endpoints.beat;
let URL1 = endpoints.assignBeat;
const beatSlice = createSlice({
  name: "beat",
  initialState,
  reducers: {
    beatSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        beat: row,
      };
    },

    beatNewSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        beatNew: row,
      };
    },

    beatIdsSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        beatIds: row,
      };
    },

    beatFromSalesTeamSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        beatFromSalesTeamId: row,
      };
    },

    beatByUserTypeSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        beatByUserType: row,
      };
    },

    beatClaimSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        beatClaim: row,
      };
    },

    outletEnquiryBeatSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        outletEnquiryBeat: row,
      };
    },

    resetState: (state = cloneDeep(initialState), action) => {
      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export const {
  beatSuccess,
  beatNewSuccess,
  beatByUserTypeSuccess,
  beatIdsSuccess,
  beatFromSalesTeamSuccess,
  beatClaimSuccess,
  outletEnquiryBeatSuccess,
  resetState,
} = beatSlice.actions;

export default beatSlice.reducer;

export const getBeat = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL + '?sort={"sortOrderNo": "ASC"}',
    }).then(({ data, success }) => {
      if (success) {
        const { content } = data.data;
        const row = content.map((beatObject, index) => {
          let beatData = {
            index: index + 1,
            id: beatObject.id === null ? "" : beatObject.id,
            beatName: beatObject.beatName === null ? "" : beatObject.beatName,
            name: beatObject.beatName === null ? "" : beatObject.beatName,
            area:
              beatObject.area !== null && beatObject.area.id
                ? beatObject.area.id
                : "",
            areaName:
              beatObject.area !== null && beatObject.area.name
                ? beatObject.area.name
                : "",
            outletCount:
              beatObject.outletCount === null ? "" : beatObject.outletCount,
            sortOrderNo:
              beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
            isActive: beatObject.isActive === null ? "" : beatObject.isActive,
          };
          return beatData;
        });
        dispatch(beatSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getBeatUpdated = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL + "/get-all",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((beatObject, index) => {
          let beatData = {
            index: index + 1,
            id: beatObject.id === null ? "" : beatObject.id,
            beatName: beatObject.beatName === null ? "" : beatObject.beatName,
            beatCode: beatObject.beatCode === null ? "-" : beatObject.beatCode,
            name: beatObject.beatName === null ? "" : beatObject.beatName,
            area: beatObject.areaId !== null ? beatObject.areaId : "",
            areaName: beatObject.areaName !== null ? beatObject.areaName : "",
            outletCount:
              beatObject.outletCount === null ? "" : beatObject.outletCount,
            sortOrderNo:
              beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
            isActive: beatObject.isActive === null ? "" : beatObject.isActive,
          };
          return beatData;
        });
        dispatch(beatSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const setBeat =
  ({ row }) =>
    async (dispatch) => {
      dispatch(beatNewSuccess({ row }));
    };

export const getBeatBySalesTeamId =
  ({ salesTeamId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL + "/with-outlet-count-by-sales-team?salesTeamId=" + salesTeamId,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                beatId: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                name: beatObject.beatName === null ? "" : beatObject.beatName,
                area:
                  beatObject.area !== null && beatObject.area.id
                    ? beatObject.area.id
                    : "",
                areaName:
                  beatObject.area !== null && beatObject.area.name
                    ? beatObject.area.name
                    : "",
                sortOrderNo:
                  beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                noOfOutlet:
                  beatObject.noOfOutlet === null ? "" : beatObject.noOfOutlet,
                isActive: beatObject.isActive === null ? "" : beatObject.isActive,
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getBeatBySalesTeamIdAndLoginPersonAreas =
  ({ salesTeamId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL +
            "/with-outlet-count-by-sales-team-and-login-areas?salesTeamId=" +
            salesTeamId,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                beatId: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                name: beatObject.beatName === null ? "" : beatObject.beatName,
                area:
                  beatObject.area !== null && beatObject.area.id
                    ? beatObject.area.id
                    : "",
                areaName:
                  beatObject.area !== null && beatObject.area.name
                    ? beatObject.area.name
                    : "",
                sortOrderNo:
                  beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                noOfOutlet:
                  beatObject.noOfOutlet === null ? "" : beatObject.noOfOutlet,
                isActive: beatObject.isActive === null ? "" : beatObject.isActive,
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getBeatBySalesTeamIdAndAreaIdPost =
  ({ salesTeamId, areaIds }) =>
    async (dispatch) => {
      try {
        const response = apiPost({
          url:
            URL +
            "/with-outlet-count-by-sales-team-and-area-new?salesTeamId=" +
            salesTeamId,
          postBody: areaIds,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                beatId: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                name: beatObject.beatName === null ? "" : beatObject.beatName,
                area:
                  beatObject.area !== null && beatObject.area.id
                    ? beatObject.area.id
                    : "",
                areaName:
                  beatObject.area !== null && beatObject.area.name
                    ? beatObject.area.name
                    : "",
                sortOrderNo:
                  beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                noOfOutlet:
                  beatObject.noOfOutlet === null ? "" : beatObject.noOfOutlet,
                isActive: beatObject.isActive === null ? "" : beatObject.isActive,
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getBeatBySalesTeamIdAndAreaId =
  ({ salesTeamId, areaId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL +
            "/with-outlet-count-by-sales-team-and-area?salesTeamId=" +
            salesTeamId +
            "&areaId=" +
            areaId,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                beatId: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                name: beatObject.beatName === null ? "" : beatObject.beatName,
                area:
                  beatObject.area !== null && beatObject.area.id
                    ? beatObject.area.id
                    : "",
                areaName:
                  beatObject.area !== null && beatObject.area.name
                    ? beatObject.area.name
                    : "",
                sortOrderNo:
                  beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                noOfOutlet:
                  beatObject.noOfOutlet === null ? "" : beatObject.noOfOutlet,
                isActive: beatObject.isActive === null ? "" : beatObject.isActive,
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getBeatBySalesTeamIdAreaId =
  ({ salesTeamId, areaId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL +
            "/with-outlet-count-and-assigned-to-by-area?salesTeamId=" +
            salesTeamId +
            "&areaId=" +
            areaId,
        }).then(({ data, success }) => {
          if (success) {
            let selectedList = [];
            const row = data.data.map((beatObject, index) => {
              if (beatObject.flag == 0) {
                selectedList.push(beatObject.id);
              }
              let beatData = {
                index: index + 1,
                id: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                name: beatObject.beatName === null ? "" : beatObject.beatName,
                area:
                  beatObject.area !== null && beatObject.area.id
                    ? beatObject.area.id
                    : "",
                areaName:
                  beatObject.area !== null && beatObject.area.name
                    ? beatObject.area.name
                    : "",
                salesTeamName:
                  beatObject.salesTeamName === null
                    ? ""
                    : beatObject.salesTeamName,
                noOfOutlet:
                  beatObject.noOfOutlet === null ? "" : beatObject.noOfOutlet,
                sortOrderNo:
                  beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                isActive: beatObject.isActive === null ? "" : beatObject.isActive,
                flag: beatObject.flag === null ? "" : beatObject.flag,
                checked: beatObject.flag == 0 ? true : false,
                // disabled: beatObject.flag == 2 ? true : false,
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            return { response: row, success, selectedList };
          }
          return { response: [], success, selectedList: [] };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getBeatBySalesTeamIdAreaIdUpdated =
  ({ salesTeamId, areaId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL +
            "/with-outlet-count-and-assigned-to-by-area-new?salesTeamId=" +
            salesTeamId +
            "&areaId=" +
            areaId,
        }).then(({ data, success }) => {
          if (success) {
            let selectedList = [];
            const row = data.data.map((beatObject, index) => {
              if (beatObject.flag == 0) {
                selectedList.push(beatObject.id);
              }
              let beatData = {
                index: index + 1,
                id: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                name: beatObject.beatName === null ? "" : beatObject.beatName,
                area: beatObject.areaId !== null ? beatObject.areaId : "",
                areaName: beatObject.areaName !== null ? beatObject.areaName : "",
                salesTeamName:
                  beatObject.salesTeamName === null
                    ? ""
                    : beatObject.salesTeamName,
                noOfOutlet:
                  beatObject.noOfOutlet === null ? "" : beatObject.noOfOutlet,
                sortOrderNo:
                  beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                isActive: beatObject.isActive === null ? "" : beatObject.isActive,
                flag: beatObject.flag === null ? "" : beatObject.flag,
                checked: beatObject.flag == 0 ? true : false,
                // disabled: beatObject.flag == 2 ? true : false,
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            return { response: row, success, selectedList };
          }
          return { response: [], success, selectedList: [] };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getBeatBySalesTeamIdForAssign =
  ({ salesTeamId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url: URL + "/assign-to-sales-team?salesTeamId=" + salesTeamId,
        }).then(({ data, success }) => {
          if (success) {
            let selectedList = [];
            const row = data.data
              .filter((rowData) => rowData.flag != 2)
              .map((beatObject, index) => {
                if (beatObject.flag == 0 || beatObject.flag == 2) {
                  selectedList.push(beatObject.id);
                }
                let beatData = {
                  index: index + 1,
                  id: beatObject.id === null ? "" : beatObject.id,
                  beatName:
                    beatObject.beatName === null ? "" : beatObject.beatName,
                  name: beatObject.beatName === null ? "" : beatObject.beatName,
                  area:
                    beatObject.area !== null && beatObject.area.id
                      ? beatObject.area.id
                      : "",
                  areaName:
                    beatObject.area !== null && beatObject.area.name
                      ? beatObject.area.name
                      : "",
                  salesTeamName:
                    beatObject.salesTeamName === null
                      ? ""
                      : beatObject.salesTeamName,
                  noOfOutlet:
                    beatObject.noOfOutlet === null ? "" : beatObject.noOfOutlet,
                  sortOrderNo:
                    beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                  isActive:
                    beatObject.isActive === null ? "" : beatObject.isActive,
                  flag: beatObject.flag === null ? "" : beatObject.flag,
                  checked: beatObject.flag == 0 ? true : false,
                  disabled: beatObject.flag == 2 ? true : false,
                };
                return beatData;
              });
            dispatch(beatSuccess({ row }));
            return { response: row, success, selectedList };
          }
          return { response: [], success, selectedList: [] };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const setBeatBySalesTeamIdAreaId =
  ({ row }) =>
    async (dispatch) => {
      dispatch(beatSuccess({ row }));
    };

// change /get-area mapping to /get-active-by-area by akash - 01-08-2024
export const getBeatByArea =
  ({ areaId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url: URL + "/get-active-by-area?areaId=" + areaId,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                id: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                name: beatObject.beatName === null ? "" : beatObject.beatName,
                area:
                  beatObject.area !== null && beatObject.area.id
                    ? beatObject.area.id
                    : "",
                areaName:
                  beatObject.area !== null && beatObject.area.name
                    ? beatObject.area.name
                    : "",
                sortOrderNo:
                  beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                languageMarathi: "",
                languageHindi: "",
                languageEnglish: "",
                languageMarathiName: "Marathi",
                languageHindiName: "Hindi",
                languageEnglishName: "English",
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            dispatch(beatNewSuccess({ row: data.data }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getBeatByAreaIds =
  ({ areaIdsJson }) =>
    async (dispatch) => {
      try {
        const response = apiPost({
          url: URL + "/active-by-areas",
          postBody: areaIdsJson,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                id: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                name:
                  beatObject.beatName !== null && beatObject.areaName !== null
                    ? beatObject.beatName + " (" + beatObject.areaName + ")"
                    : "",
                area: beatObject.areaId !== null ? beatObject.areaId : "",
                areaName: beatObject.areaName ? beatObject.areaName : "",
                sortOrderNo:
                  beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                languageMarathi: "",
                languageHindi: "",
                languageEnglish: "",
                languageMarathiName: "Marathi",
                languageHindiName: "Hindi",
                languageEnglishName: "English",
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            dispatch(beatNewSuccess({ row: data.data }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getActiveBeatByArea =
  ({ areaId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url: URL + "/active-by-area?areaId=" + areaId,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                id: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                name: beatObject.beatName === null ? "" : beatObject.beatName,
                area: beatObject.areaId !== null ? beatObject.areaId : "",
                sortOrderNo:
                  beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                languageMarathi: "",
                languageHindi: "",
                languageEnglish: "",
                languageMarathiName: "Marathi",
                languageHindiName: "Hindi",
                languageEnglishName: "English",
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            dispatch(beatNewSuccess({ row: data.data }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getChangeActiveBeat =
  ({ row }) =>
    async (dispatch) => {
      console.log(row);
      dispatch(beatSuccess({ row }));
    };

export const getBeatsByAreaIds =
  ({ areaIds }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url: URL + "/by-areas?areaIds=" + areaIds,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                id: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                name: beatObject.beatName === null ? "" : beatObject.beatName,
                area:
                  beatObject.area !== null && beatObject.area.id
                    ? beatObject.area.id
                    : "",
                areaName:
                  beatObject.area !== null && beatObject.area.name
                    ? beatObject.area.name
                    : "",
                outletCount:
                  beatObject.outletCount === null ? "" : beatObject.outletCount,
                sortOrderNo:
                  beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                isActive: beatObject.isActive === null ? "" : beatObject.isActive,
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getUpdatedBeatsByAreaIds =
  ({ areaIds }) =>
    async (dispatch) => {
      try {
        const response = apiPost({
          // http://localhost:8088/api/distribution/v1/beat/list-by-areas-new
          url: URL + "/list-by-areas-new",
          postBody: areaIds,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                id: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                name: beatObject.beatName === null ? "" : beatObject.beatName,
                area: beatObject.areaId !== null ? beatObject.areaId : "",
                areaName: beatObject.areaName !== null ? beatObject.areaName : "",
                outletCount:
                  beatObject.outletCount === null ? "" : beatObject.outletCount,
                sortOrderNo:
                  beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                isActive: beatObject.isActive === null ? "" : beatObject.isActive,
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };
export const getBeatByUserType = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL + "/by-user-type",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((beat, index) => {
          let beatByUserTypeData = {
            index: index + 1,
            id: beat.id === null ? "" : beat.id,
            beatName: beat.beatName === null ? "" : beat.beatName,
            beatCode: beat.beatCode === null ? "-" : beat.beatCode,
            name: beat.beatName === null ? "" : beat.beatName,
            area: beat.area !== null && beat.area.id ? beat.area.id : "",
            areaName:
              beat.area !== null && beat.area.name ? beat.area.name : "",
            outletCount: beat.outletCount === null ? "" : beat.outletCount,
            sortOrderNo: beat.sortOrderNo === null ? "" : beat.sortOrderNo,
            isActive: beat.isActive === null ? "" : beat.isActive,
          };
          return beatByUserTypeData;
        });
        dispatch(beatByUserTypeSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getUpdatedBeatByUserType = () => async (dispatch) => {
  try {
    const response = apiGet({
      // http://localhost:8088/api/distribution/v1/beat/list-by-user-type

      url: URL + "/list-by-user-type",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((beat, index) => {
          let beatByUserTypeData = {
            index: index + 1,
            id: beat.id === null ? "" : beat.id,
            beatName: beat.beatName === null ? "" : beat.beatName,
            name: beat.beatName === null ? "" : beat.beatName,
            area: beat.areaId !== null ? beat.areaId : "",
            areaName: beat.areaName !== null ? beat.areaName : "",
            outletCount: beat.outletCount === null ? "" : beat.outletCount,
            sortOrderNo: beat.sortOrderNo === null ? "" : beat.sortOrderNo,
            isActive: beat.isActive === null ? "" : beat.isActive,
          };
          return beatByUserTypeData;
        });
        dispatch(beatByUserTypeSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};


export const getBeatListByUserType = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL + "/get-list-by-user-type",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((beat, index) => {
          let beatByUserTypeData = {
            index: index + 1,
            id: beat.id === null ? "" : beat.id,
            beatName: beat.beatName === null ? "" : beat.beatName,
            name: beat.beatName === null ? "" : beat.beatName,
            area: beat.areaId !== null ? beat.areaId : "",
            areaName: beat.areaName !== null ? beat.areaName : "",
            outletCount: beat.outletCount === null ? "" : beat.outletCount,
            sortOrderNo: beat.sortOrderNo === null ? "" : beat.sortOrderNo,
            isActive: beat.isActive === null ? "" : beat.isActive,
          };
          return beatByUserTypeData;
        });
        dispatch(beatByUserTypeSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getBeatFromSalesTeamId =
  ({ salesTeamIds }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url: URL + "/todays-assign-by-sales-team?salesTeamId=" + salesTeamIds,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                beatId: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                name: beatObject.beatName === null ? "" : beatObject.beatName,
                area:
                  beatObject.area !== null && beatObject.area.id
                    ? beatObject.area.id
                    : "",
                areaName:
                  beatObject.area !== null && beatObject.area.name
                    ? beatObject.area.name
                    : "",
                sortOrderNo:
                  beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                outletCount:
                  beatObject.outletCount === null ? "" : beatObject.outletCount,
                isActive: beatObject.isActive === null ? "" : beatObject.isActive,
              };
              return beatData;
            });
            dispatch(beatFromSalesTeamSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getSelectedBeatCountFromSalesTeamIdAndDate =
  ({ salesTeamId, fromDate, toDate }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL +
            "/ordered-beats-by-sales-team?salesTeamId=" +
            salesTeamId +
            "&fromDate=" +
            fromDate +
            "&toDate=" +
            toDate,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                beatId: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                name: beatObject.beatName === null ? "" : beatObject.beatName,
                area:
                  beatObject.area !== null && beatObject.area.id
                    ? beatObject.area.id
                    : "",
                areaName:
                  beatObject.area !== null && beatObject.area.name
                    ? beatObject.area.name
                    : "",
                sortOrderNo:
                  beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                outletCount:
                  beatObject.outletCount === null ? "" : beatObject.outletCount,
                isActive: beatObject.isActive === null ? "" : beatObject.isActive,
              };
              return beatData;
            });
            dispatch(beatFromSalesTeamSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getBeatsByAreasPost =
  ({ beatDataForPost }) =>
    async (dispatch) => {
      try {
        const response = apiPost({
          url: URL + "/list-by-areas",
          postBody: beatDataForPost,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatPostData = {
                index: index + 1,
                id: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                name: beatObject.beatName === null ? "" : beatObject.beatName,
                area:
                  beatObject.area !== null && beatObject.area.id
                    ? beatObject.area.id
                    : "",
                areaName:
                  beatObject.area !== null && beatObject.area.name
                    ? beatObject.area.name
                    : "",
                outletCount:
                  beatObject.outletCount === null ? "" : beatObject.outletCount,
                sortOrderNo:
                  beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                isActive: beatObject.isActive === null ? "" : beatObject.isActive,
              };

              return beatPostData;
            });
            dispatch(beatSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getBeatsByAreasPostUpdated =
  ({ beatDataForPost }) =>
    async (dispatch) => {
      try {
        const response = apiPost({
          url: URL + "/list-by-areas-new",
          postBody: beatDataForPost,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatPostData = {
                index: index + 1,
                id: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                beatCode: beatObject.beatCode === null ? "-" : beatObject.beatCode,
                name: beatObject.beatName === null ? "" : beatObject.beatName,
                area: beatObject.areaId !== null ? beatObject.areaId : "",
                areaName: beatObject.areaName !== null ? beatObject.areaName : "",
                outletCount:
                  beatObject.outletCount === null ? "" : beatObject.outletCount,
                sortOrderNo:
                  beatObject.sortOrderNo === null ? "" : beatObject.sortOrderNo,
                isActive: beatObject.isActive === null ? "" : beatObject.isActive,
              };

              return beatPostData;
            });
            dispatch(beatSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getBeatBySalesTeamIdAreaIdForAllowance =
  ({ salesTeamId, areaId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL1 +
            "/with-claim-allowance?salesTeamId=" +
            salesTeamId +
            "&areaId=" +
            areaId,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                id: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                beatId: beatObject.beatId === null ? "" : beatObject.beatId,
                dailyAllowance:
                  beatObject.dailyAllowance === null
                    ? ""
                    : beatObject.dailyAllowance,
                beatType: beatObject.beatType === null ? "" : beatObject.beatType,
                ratePerKm:
                  beatObject.ratePerKm === null ? "" : beatObject.ratePerKm,
                distance:
                  beatObject.distanceFromHq === null
                    ? ""
                    : beatObject.distanceFromHq,
                isChecked:
                  beatObject.isAssign === null
                    ? ""
                    : beatObject.isAssign == 0
                      ? false
                      : true,
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getBeatBySalesTeamIdAreaIdForAllowancePostAPI =
  ({ jsonData }) =>
    async (dispatch) => {
      try {
        const response = apiPost({
          url: URL1 + "/with-claim-allowance",
          postBody: jsonData,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                id: beatObject.id === null ? "" : beatObject.id,
                beatId: beatObject.beatId === null ? "" : beatObject.beatId,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                townId: beatObject.townId === null ? "" : beatObject.townId,
                townName: beatObject.townName === null ? "" : beatObject.townName,
                areaName: beatObject.areaName === null ? "" : beatObject.areaName,
                beatId: beatObject.beatId === null ? "" : beatObject.beatId,
                dailyAllowance:
                  beatObject.dailyAllowance === null
                    ? ""
                    : beatObject.dailyAllowance,
                beatType: beatObject.beatType === null ? "" : beatObject.beatType,
                ratePerKm:
                  beatObject.ratePerKm !== null ? beatObject.ratePerKm : "",
                distance:
                  beatObject.distanceFromHq !== null &&
                    beatObject.beatAssignDistanceFromHq !== null &&
                    beatObject.isAssign !== null
                    ? beatObject.isAssign == 1
                      ? beatObject.beatAssignDistanceFromHq
                      : beatObject.distanceFromHq
                    : "",
                isChecked:
                  beatObject.isAssign === null
                    ? ""
                    : beatObject.isAssign == 0
                      ? false
                      : true,
                beatAssignDistanceFromHq:
                  beatObject.beatAssignDistanceFromHq === null
                    ? ""
                    : beatObject.beatAssignDistanceFromHq,
                salesTeamName:
                  beatObject.salesTeamName === null
                    ? ""
                    : beatObject.salesTeamName,
                isCheckedForEndUser:
                  beatObject.isSelfAssign === null
                    ? ""
                    : beatObject.isSelfAssign == 1
                      ? true
                      : false,
                isSelfAssign:
                  beatObject.isSelfAssign !== null ? beatObject.isSelfAssign : "",
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getBeatBySalesTeamIdAndReportingId =
  ({ jsonData }) =>
    async (dispatch) => {
      try {
        const response = apiPost({
          url: URL1 + "/beats-by-sales-team-ids-for-user",
          postBody: jsonData,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                id: beatObject.id === null ? "" : beatObject.id,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                areaName: beatObject.areaName === null ? "" : beatObject.areaName,
                beatId: beatObject.beatId === null ? "" : beatObject.beatId,
                dailyAllowance:
                  beatObject.dailyAllowance === null
                    ? ""
                    : beatObject.dailyAllowance,
                beatType: beatObject.beatType === null ? "" : beatObject.beatType,
                ratePerKm:
                  beatObject.ratePerKm !== null && beatObject.beatType !== null
                    ? beatObject.beatType == 0
                      ? 0
                      : beatObject.ratePerKm
                    : "",
                salesTeamId:
                  beatObject.salesTeamId === null ? "" : beatObject.salesTeamId,
                salesTeamName:
                  beatObject.salesTeamName === null
                    ? ""
                    : beatObject.salesTeamName,
                distance:
                  beatObject.distanceFromHq !== null &&
                    beatObject.beatAssignDistanceFromHq !== null &&
                    beatObject.isAssign !== null
                    ? beatObject.isAssign == 1
                      ? beatObject.beatAssignDistanceFromHq
                      : beatObject.distanceFromHq
                    : "",
                isChecked:
                  beatObject.isAssign === null
                    ? ""
                    : beatObject.isAssign == 0
                      ? false
                      : true,
                beatAssignDistanceFromHq:
                  beatObject.beatAssignDistanceFromHq === null
                    ? ""
                    : beatObject.beatAssignDistanceFromHq,
                isCheckedForEndUser:
                  beatObject.isSelfAssign === null
                    ? ""
                    : beatObject.isSelfAssign == 1
                      ? true
                      : false,
                isSelfAssign:
                  beatObject.isSelfAssign !== null ? beatObject.isSelfAssign : "",
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getClaimDetailsForDayEndBeats =
  ({ date, salesTeamId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL +
            "/claim-details-for-day-end-beats?date=" +
            date +
            "&salesTeamId=" +
            salesTeamId,
        }).then(({ data, success }) => {
          if (success) {
            let dataObj = data.data;
            let beatClaimData = {
              claimStatus:
                dataObj.claimStatus === null
                  ? ""
                  : dataObj.claimStatus == 0
                    ? "Pending"
                    : dataObj.claimStatus == 1
                      ? "Cancelled"
                      : dataObj.claimStatus == 2
                        ? "Approve"
                        : "Reject",
              finalTotal:
                dataObj.finalTotal === null ? "" : dataObj.finalTotal.toFixed(2),
              beatWorkInfo:
                dataObj.beatWorkInfo === null
                  ? ""
                  : dataObj.beatWorkInfo.map((beatObject, index) => {
                    let beatData = {
                      index: index + 1,
                      id: beatObject.id === null ? "" : beatObject.id,
                      beatId:
                        beatObject.beatId === null ? "" : beatObject.beatId,
                      beatName:
                        beatObject.beatName === null ? "" : beatObject.beatName,
                      travelAllowanceAmt:
                        beatObject.travelAllowance !== null &&
                          beatObject.travelAllowance.amt !== null
                          ? beatObject.travelAllowance.amt.toFixed(2)
                          : "",
                      dailyAllowanceAmt:
                        beatObject.dailyAllowance !== null &&
                          beatObject.dailyAllowance.amt !== null
                          ? beatObject.dailyAllowance.amt.toFixed(2)
                          : "",
                      total:
                        beatObject.total === null
                          ? ""
                          : beatObject.total.toFixed(2),
                    };
                    return beatData;
                  }),
            };
            dispatch(beatClaimSuccess({ row: beatClaimData }));
            return { response: beatClaimData, success };
          }
          return { response: {}, success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const setBeatList =
  ({ row }) =>
    async (dispatch) => {
      dispatch(beatSuccess({ row }));
    };

export const getTodaysAssignBeatsWithArea =
  ({ areaId, isProjectionApplicable }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL +
            "/todays-assign-beats-with-distributors-by-area?areaId=" +
            areaId +
            "&isProjectionApplicable=" +
            isProjectionApplicable,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                id:
                  beatObject.beat !== null && beatObject.beat.id !== null
                    ? beatObject.beat.id
                    : "",
                name:
                  beatObject.beat !== null && beatObject.beat.beatName !== null
                    ? beatObject.beat.beatName
                    : "",
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getBeatByBeatTypeAndAreas =
  ({ jsonData, beatType }) =>
    async (dispatch) => {
      try {
        const response = apiPost({
          url: URL1 + "/by-beat-type-or-areas?beatType=" + beatType,
          postBody: jsonData,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((beatObject, index) => {
              let beatData = {
                index: index + 1,
                id: beatObject.id === null ? "" : beatObject.id,
                beatId: beatObject.beatId === null ? "" : beatObject.beatId,
                beatName: beatObject.beatName === null ? "" : beatObject.beatName,
                townId: beatObject.townId === null ? "" : beatObject.townId,
                townName: beatObject.townName === null ? "" : beatObject.townName,
                areaName: beatObject.areaName === null ? "" : beatObject.areaName,
                beatId: beatObject.beatId === null ? "" : beatObject.beatId,
                dailyAllowance:
                  beatObject.dailyAllowance === null
                    ? ""
                    : beatObject.dailyAllowance,
                beatType: beatObject.beatType === null ? "" : beatObject.beatType,
                beatSubType: beatObject.beatSubType === null ? "" : beatObject.beatSubType,
                ratePerKm:
                  beatObject.ratePerKm !== null ? beatObject.ratePerKm : "",
                distance:
                  beatObject.distanceFromHq !== null &&
                    beatObject.beatAssignDistanceFromHq !== null &&
                    beatObject.isAssign !== null
                    ? beatObject.isAssign == 1
                      ? beatObject.beatAssignDistanceFromHq
                      : beatObject.distanceFromHq
                    : "",
                isChecked:
                  beatObject.isAssign === null
                    ? ""
                    : beatObject.isAssign == 0
                      ? false
                      : true,
                beatAssignDistanceFromHq:
                  beatObject.beatAssignDistanceFromHq === null
                    ? ""
                    : beatObject.beatAssignDistanceFromHq,
                salesTeamName:
                  beatObject.salesTeamName === null
                    ? ""
                    : beatObject.salesTeamName,
                isCheckedForEndUser:
                  beatObject.isSelfAssign === null
                    ? ""
                    : beatObject.isSelfAssign == 1
                      ? true
                      : false,
                isSelfAssign:
                  beatObject.isSelfAssign !== null ? beatObject.isSelfAssign : "",
              };
              return beatData;
            });
            dispatch(beatSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };



export const getTownDistributorSalesTeamByBeatId =
  ({ beatId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url: URL + "/town-distributor-sales-team-by-beat?beatId=" + beatId,
        }).then(({ data, success }) => {
          if (success) {

            const dataObj = data.data;
            const BeatData = {
              townId: dataObj?.town?.id ?? "",
              townName: dataObj?.town?.name ?? "",
              stockStakeHolders:
                dataObj?.stockStakeHolders?.map((data, index) => {
                  return {
                    index: index + 1,
                    id: data.stockStakeHolderId ?? "",
                    name: data.stockStakeHolderFirmName ?? "",
                    stockStakeHolderTypeId: data.stockStakeHolderTypeId ?? "",
                    stockStakeHolderTypeName: data.stockStakeHolderTypeName ?? "",
                    stockStakeHolderOwnerName: data.stockStakeHolderOwnerName ?? "",
                  }
                }) ?? [],
              salesTeams:
                dataObj?.salesTeams?.map((data, index) => {
                  return {
                    index: index + 1,
                    id: data.id ?? "",
                    name: data.name ?? "",
                    stockStakeHolderTypeId: data.stockStakeHolderTypeId ?? "",
                    stockStakeHolderTypePrefix: data.stockStakeHolderTypePrefix ?? "",
                  }
                }) ?? [],
              potentialRates:
                dataObj?.potentialRates?.map((data, index) => {
                  return {
                    index: index + 1,
                    id: data.id ?? "",
                    name: data.label ?? "",
                  }
                }) ?? [],
              enquiryPlatforms:
                dataObj?.enquiryPlatforms?.map((data, index) => {
                  return {
                    index: index + 1,
                    id: data.id ?? "",
                    name: data.name ?? "",
                  }
                }) ?? [],
              states:
                dataObj?.states?.map((data, index) => {
                  return {
                    index: index + 1,
                    id: data.id ?? "",
                    name: data.name ?? "",
                  }
                }) ?? [],
            };

            dispatch(outletEnquiryBeatSuccess({ row: BeatData }));
            return { response: BeatData, success };
          }
          return { response: {}, success };
        });
        return response;
      } catch (e) {
        return { response: {}, success: false };
      }
    };